import Report from "components/Report";
import ls from "Localization";
import _ from "lodash";
import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useRouteMatch } from "react-router-dom";
import { Access } from "types/Access";
import PermissionAddModal from "../../components/PermissionAddModal";
import { getPermissionsPerGroup, setValue } from "./actions";

let getPermissionsPerGroupDebounced = null;

function PermissionsReport() {
	const dispatch = useDispatch();

	const {
		params: { id }
	} = useRouteMatch();

	const state = useSelector(s => s.permissionGroups);

	const table = useRef(null);

	const handleFetchData = tableState => {
		if (!tableState) return;
		let { page, pageSize, sorted, filtered, toExport, callback } = tableState;

		if (getPermissionsPerGroupDebounced) {
			getPermissionsPerGroupDebounced.cancel();
		}

		if (!sorted) sorted = [];

		let creationDate = filtered.find(c => c.id === "creationDate");

		if (creationDate && creationDate.value) {
			filtered = filtered.filter(c => c.id !== "creationDate");

			if (creationDate && creationDate.value.startDate) {
				filtered.push({
					id: "startDate",
					value: creationDate.value.startDate
				});
			}

			if (creationDate && creationDate.value.endDate)
				filtered.push({
					id: "endDate",
					value: creationDate.value.endDate
				});
		}

		getPermissionsPerGroupDebounced = _.debounce(
			() =>
				dispatch(
					getPermissionsPerGroup(
						page * pageSize,
						10,
						filtered.reduce(
							(p, c) => p + `&filters[${c.id}]=${c.value}`,
							`&filters[group]=${id}`
						),
						sorted[0] ? sorted[0].id : undefined,
						sorted[0] ? sorted[0].desc : undefined,
						toExport,
						callback
					)
				),
			500
		);

		getPermissionsPerGroupDebounced();
	};

	const load = () =>
		handleFetchData(table.current ? table.current.state : undefined);

	useEffect(() => {
		load();
	}, []);

	return (
		<Report
			manual
			tableRef={table}
			title={"Permissões"}
			headerRightComponent={<PermissionAddModal load={load} />}
			onRowClicked={p => {
				dispatch(setValue({ showCreateModal: true }));
				dispatch(setValue({ groupPermission: p }));
			}}
			data={state.items}
			pages={state.pages}
			loading={state.loading.getAll}
			onFetchData={handleFetchData}
			defaultSorted={[
				{
					id: "createdAt",
					desc: true
				}
			]}
			pageSize={
				state.items.length > 10
					? 10
					: state.items.length <= 0
					? 1
					: state.items.length + 1
			}
			columns={[
				{
					Header: "Nome",
					id: "name",
					width: 250,
					accessor: "permission.name"
				},
				{
					Header: "Usuário",
					id: "user",
					accessor: ({ access }) => (access ? ls[Access[access[0]]] : null)
				},
				{
					Header: "Empresa",
					id: "group",
					accessor: ({ access }) => (access ? ls[Access[access[1]]] : null)
				},
				{
					Header: "Geral",
					id: "all",
					accessor: ({ access }) => (access ? ls[Access[access[2]]] : null)
				}
			]}
		/>
	);
}

export default PermissionsReport;
